// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tabs--tab--1GYl_","tab-selected":"Tabs--tab-selected--2Yol3","tabSelected":"Tabs--tab-selected--2Yol3"};